import React from 'react';
import Router from './router/Router';
import { GlobalStyle } from './style/GlobalStyle';
import './assets/css/font.css';
const App = () => {
  return (
    <>
      <GlobalStyle />
      <Router />
    </>
  );
};

export default App;
